/*!

=========================================================
* Argon Dashboard React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useState, useEffect } from "react";
import { NavLink as NavLinkRRD, Link } from "react-router-dom";
import NumberFormat from "react-number-format"
import axios from "axios";
// reactstrap components
import {
  Card,
  Button,
  NavLink,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  CardTitle,
  UncontrolledTooltip,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Select
} from "reactstrap";

const ProductsCard = () => {
  return (
    <>
      <div className="pt-5 pt-md-8 container-fluid">
        <h2 class="ml-2">Crear una cuenta Asociada</h2>
      </div>
      <div className="pb-8 pt-md-2">
        <Container fluid>
          <div className="header-body">
          <Form>
          <Row>
          <Col xl="4" md="6" sm="6">
              <FormGroup>
                <InputGroup className="input-group-alternative mb-4">
                  <Input placeholder="Nombre" type="text" />
                  <InputGroupAddon addonType="append">
                    <InputGroupText>
                      <i className="ni ni-single-02" />
                    </InputGroupText>
                  </InputGroupAddon>
                </InputGroup>
              </FormGroup>
            </Col>
            <Col xl="4" md="6" sm="6">
              <FormGroup>
                <select class="selectpicker" placeholder="Tipo de Docuemnto" className="form-control input-group-alternative" data-live-search="true">
                    <option data-tokens="ketchup mustard">Cédula de Ciudadanía</option>
                    <option data-tokens="mustard">Tarjeta de Identidad</option>
                    <option data-tokens="frosting">Cédula de Extranjería</option>
                </select>
              </FormGroup>
            </Col>
            <Col xl="4" md="6" sm="6">
              <FormGroup>
                <InputGroup className="input-group-alternative mb-4">
                  <Input placeholder="Numero de Documento" type="text" />
                  <InputGroupAddon addonType="append">
                    <InputGroupText>
                      <i className="ni ni-single-02" />
                    </InputGroupText>
                  </InputGroupAddon>
                </InputGroup>
              </FormGroup>
            </Col>
          </Row>
          <Row>
          
            <Col xl="4" md="6" sm="6">
              <FormGroup>
                <InputGroup className="input-group-alternative mb-4">
                  <Input placeholder="Alias de la Cuenta" type="text" />
                  <InputGroupAddon addonType="append">
                    <InputGroupText>
                      <i className="ni ni-single-02" />
                    </InputGroupText>
                  </InputGroupAddon>
                </InputGroup>
              </FormGroup>
            </Col>
            <Col xl="4" md="6" sm="6">
              <FormGroup>
                <select class="selectpicker" placeholder="Tipo de Cuenta" className="form-control input-group-alternative" data-live-search="true">
                    <option data-tokens="ketchup mustard">Cuenta de Ahorros</option>
                    <option data-tokens="mustard">Cuenta Corriente</option>
                    <option data-tokens="frosting">Prestamos</option>
                </select>
              </FormGroup>
            </Col>
            <Col xl="4" md="6" sm="6">
              <FormGroup>
                <InputGroup className="input-group-alternative mb-4">
                  <Input placeholder="Alias de la Cuenta" type="text" />
                  <InputGroupAddon addonType="append">
                    <InputGroupText>
                      <i className="ni ni-single-02" />
                    </InputGroupText>
                  </InputGroupAddon>
                </InputGroup>
              </FormGroup>
            </Col>
          </Row>
          <Row>
          <Col xl="4" md="6" sm="6">
              <FormGroup>
                <select class="selectpicker" placeholder="Banco" className="form-control input-group-alt ernative" data-live-search="true">
                    <option data-tokens="ketchup mustard">Banco de Bogota</option>
                    <option data-tokens="mustard">Bancolombia</option>
                    <option data-tokens="frosting">Avvillas</option>
                </select>
              </FormGroup>
            </Col>
            <Col xl="4" md="6" sm="6">
              <FormGroup>
                <select class="selectpicker" placeholder="Ciudad" className="form-control input-group-alternative" data-live-search="true">
                    <option data-tokens="ketchup mustard">Tunja</option>
                    <option data-tokens="mustard">Bogota</option>
                    <option data-tokens="frosting">Cali</option>
                </select>
              </FormGroup>
            </Col>
          </Row>
        </Form>
          </div>
        </Container>
      </div>
    </>
  );
};

export default ProductsCard;
